import { render, staticRenderFns } from "./BillingDocumentList.vue?vue&type=template&id=51f9009c"
import script from "./BillingDocumentList.vue?vue&type=script&lang=js"
export * from "./BillingDocumentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports